export const AllowedGridEntityTypes = [
  'Campaign',
];
